/**
 * @link https://unicode-table.com/cn/blocks/enclosed-alphanumerics/
 */

/**
 * circle
 */
export const list_range_raw = [
	[
		9450,
		[
			9312,
			9332
		],
		[
			12881,
			12896
		],
		[
			12977,
			12992
		]
	],
	[
		9471,
		[
			10102,
			10112
		],
		[
			9451,
			9461
		]
	],
	[
		[
			10102,
			10112
		],
		[
			9451,
			9461
		]
	],
	[
		[
			10122,
			10132
		],
		[
			9451,
			9461
		]
	],
	[
		[
			9461,
			9471
		]
	],
	[
		[
			10112,
			10122
		]
	]
];

/**
 * circle
 */
export const list_range = [
	[
		"⓪",
		"①",
		"②",
		"③",
		"④",
		"⑤",
		"⑥",
		"⑦",
		"⑧",
		"⑨",
		"⑩",
		"⑪",
		"⑫",
		"⑬",
		"⑭",
		"⑮",
		"⑯",
		"⑰",
		"⑱",
		"⑲",
		"⑳",
		"㉑",
		"㉒",
		"㉓",
		"㉔",
		"㉕",
		"㉖",
		"㉗",
		"㉘",
		"㉙",
		"㉚",
		"㉛",
		"㉜",
		"㉝",
		"㉞",
		"㉟",
		"㊱",
		"㊲",
		"㊳",
		"㊴",
		"㊵",
		"㊶",
		"㊷",
		"㊸",
		"㊹",
		"㊺",
		"㊻",
		"㊼",
		"㊽",
		"㊾",
		"㊿"
	],
	[
		"⓿",
		"❶",
		"❷",
		"❸",
		"❹",
		"❺",
		"❻",
		"❼",
		"❽",
		"❾",
		"❿",
		"⓫",
		"⓬",
		"⓭",
		"⓮",
		"⓯",
		"⓰",
		"⓱",
		"⓲",
		"⓳",
		"⓴"
	],
	[
		"❶",
		"❷",
		"❸",
		"❹",
		"❺",
		"❻",
		"❼",
		"❽",
		"❾",
		"❿",
		"⓫",
		"⓬",
		"⓭",
		"⓮",
		"⓯",
		"⓰",
		"⓱",
		"⓲",
		"⓳",
		"⓴"
	],
	[
		"➊",
		"➋",
		"➌",
		"➍",
		"➎",
		"➏",
		"➐",
		"➑",
		"➒",
		"➓",
		"⓫",
		"⓬",
		"⓭",
		"⓮",
		"⓯",
		"⓰",
		"⓱",
		"⓲",
		"⓳",
		"⓴"
	],
	[
		"⓵",
		"⓶",
		"⓷",
		"⓸",
		"⓹",
		"⓺",
		"⓻",
		"⓼",
		"⓽",
		"⓾"
	],
	[
		"➀",
		"➁",
		"➂",
		"➃",
		"➄",
		"➅",
		"➆",
		"➇",
		"➈",
		"➉"
	]
];

export default list_range;

